export default __webpack_public_path__ + "static/media/WeldingConnectionsImg.d6e00dc8.jpg";